var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M22.222 18.667H9.778c-2.915 0-4.373 0-5.406.723-.382.268-.714.6-.982.983-.723 1.033-.723 2.49-.723 5.405 0 1.457 0 2.186.361 2.703a2 2 0 0 0 .491.49c.517.363 1.246.363 2.703.363h19.556c1.457 0 2.186 0 2.703-.362.19-.134.357-.3.49-.491.362-.517.362-1.246.362-2.703 0-2.915 0-4.372-.723-5.405a4.007 4.007 0 0 0-.982-.983c-1.034-.723-2.491-.723-5.406-.723Zm4.445 0-.543-4.884c-.376-3.384-.564-5.077-1.703-6.097-1.14-1.019-2.842-1.019-6.248-1.019h-4.346c-3.406 0-5.109 0-6.248 1.02-1.139 1.019-1.327 2.712-1.703 6.096l-.543 4.884m10-16h3.334m0 0H22m-3.333 0v4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m12 23.333 1.328.886c.438.291.953.447 1.48.447h2.384a2.66 2.66 0 0 0 1.48-.448L20 23.333m-9.333-12.666h2.666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashRegister);
export default __webpack_public_path__ + "static/media/cash-register.bd2887f2.svg";
export { ForwardRef as ReactComponent };